import { useGetDriversQuery } from '@/pages/Business/pages/Drivers/services';
import { Option } from '@/components/inputs/AutocompleteInput';
import { useState, useMemo } from 'react';

export const useDriverSearch = (initialDriver: Option | null) => {
  const [driverSearch, setDriverSearch] = useState('');

  const { data: driversData, isLoading: isDriversLoading } = useGetDriversQuery(
    {
      filters: { search: driverSearch },
      paginated: { page: 1, pageSize: 20 },
    },
    { skip: driverSearch.length < 3 && !initialDriver }
  );

  const driverOptions: Option[] = useMemo(() => {
    return (driversData?.items ?? []).map((driver) => ({
      label: `${driver.firstName} ${driver.lastName}`,
      data: driver.id,
    }));
  }, [driversData]);

  return {
    setDriverSearch,
    driverOptions,
    isDriversLoading,
  };
};
